import { render } from "./Banner.vue?vue&type=template&id=a2fea148&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=a2fea148&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2fea148"],['__file',"src/components/Banner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a2fea148"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a2fea148', __exports__)) {
    console.log('reload')
    api.reload('a2fea148', __exports__)
  }
  
  module.hot.accept("./Banner.vue?vue&type=template&id=a2fea148&scoped=true", () => {
    console.log('re-render')
    api.rerender('a2fea148', render)
  })

}


export default __exports__